import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { waQuote } from "../data/site";

export default function ServiceCard({ service, index = 0 }) {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";
  const d = service[lang] || service.es;

  return (
    <Link
      to={`${prefix}/servicios/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="card-sheen group relative flex flex-col overflow-hidden rounded-xl border border-white/5 bg-[#121212] transition-all duration-300 hover:-translate-y-1 hover:border-[#63E51D]/50 hover:shadow-[0_0_25px_rgba(99,229,29,0.15)]"
      style={{ transitionDelay: `${index * 20}ms` }}
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={service.img}
          alt={d.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent" />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white group-hover:text-[#8BFF32]">
          {d.name}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-zinc-400">{d.short}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#63E51D]">
          {t("home.viewService")}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}
